import { AfterViewInit, ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { AppCoreService } from 'src/app/services/app-core.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ColumnApi, GridApi, GridOptions, GridReadyEvent } from 'ag-grid-community';
import { AWBService } from 'src/app/services/operations/awb.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AwbEditDeleteActionsRenderer } from 'src/app/components/shared/ag-grid/cell-renderers/awb-editdelete.component';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UpdatePODDetails } from '../pod-details/updatepod-details.component';
import { CommentsComponent } from '../comments/comments.component';
import { AwbReceivedComponent } from '../awb-received/awb-received.component';
import printJS from 'print-js-updated';
import { AwbSplitComponent } from '../awb-split/awb-split.component';
import { ConfigService } from 'src/app/services/system-config/configs/configs.service';
import { lastValueFrom } from 'rxjs';
import { UploadDocumentComponent } from '../uploaddocument/upload-document.component';
import { LabelPrintComponent } from '../label-print/label-print.component';
import { Title } from '@angular/platform-browser';
import { UserData } from 'src/app/models/user.data-object';
import { CreditControlService } from 'src/app/services/system-config/credit-control/creditcontrol';
import { KycViewComponent } from '../../tracking/kyc-modal/kyc-view.component';
import { Utilities } from 'src/app/models/utilities';
@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})

export class ListAwbComponent implements AfterViewInit {

  filterForm!: FormGroup
  awbList = [];
  selectedInscan: any;
  isCustomerLogin = false;
  isFilterAppplyDisable = false;
  isCreditControlChecked = false;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  ngbModalOptions: NgbModalOptions = {
    ariaLabelledBy: 'modal-basic-title',
    size: 'lg',
    backdrop: 'static',
    keyboard: false,
    centered: true
  };
  isFilterApplyDisable = true;
  isActionAllowed = true;
  createdBy: string;

  public isCollapsed = true;
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public context: any;
  defaultColDef = {
    filter: true,
    sortable: true,
    resizable: false,
    flex: 1,
    minWidth: 120,
  };
  awbId: number;
  gridOptions: GridOptions = {
    pagination: true,
    paginationPageSize: 20,
    domLayout: 'autoHeight',
    // getRowClass: params => {
    //   if (params.node.rowIndex % 2 === 0) {
    //       return 'grid-row-background';
    //   }
    // },
    // getRowStyle: params => {
    //   if (params.node.rowIndex % 2 === 0) {
    //       // return 'grid-row-background';
    //       return { background: '#eee' }
    //   }
    // },
  }
  columnDefs = [
    { headerName: 'AWB No', field: 'awbnumber', pinned: 'left', maxWidth: 120 },
    {
      headerName: 'Booking Date',
      field: 'bookingdate',
      maxWidth: 150,
      filter: 'agDateColumnFilter',
      sortable: true,
      comparator: (valueA: string, valueB: string) => {
        if (!valueA || !valueB) return 0; // Handle empty values

        const [dayA, monthA, yearA] = valueA.split('-').map(Number);
        const [dayB, monthB, yearB] = valueB.split('-').map(Number);

        return new Date(yearA, monthA - 1, dayA).getTime() - new Date(yearB, monthB - 1, dayB).getTime();
      },
      filterParams: {
        comparator: (filterDate: Date, cellValue: string) => {
          if (!cellValue) return 0;

          const [day, month, year] = cellValue.split('-').map(Number);
          const cellDate = new Date(year, month - 1, day).setHours(0, 0, 0, 0); // Normalize to start of day
          const filterTime = filterDate.setHours(0, 0, 0, 0); // Normalize to start of day

          if (cellDate < filterTime) return 1;
          if (cellDate > filterTime) return -1;
          return 0;
        },
        browserDatePicker: true,
        defaultOption: 'inRange',
        suppressAndOrCondition: true,
        suppressFilterButton: false,
        buttons: ['reset'],
        inRangeInclusive: true,
      }
    },
    { headerName: 'Customer Name', field: 'customername', minWidth: 250 },
    { headerName: 'Shipper', field: 'shippername', minWidth: 250 },

    { headerName: 'Consignee', field: 'consigneename', minWidth: 250 },
    { headerName: 'Destination', field: 'city', maxWidth: 120 },
    { headerName: 'Product', field: 'productname', minWidth: 200 },
    { headerName: 'Vendor', field: 'vendorname', minWidth: 200 },
    { headerName: 'Pieces', field: 'totalpieces', maxWidth: 70, cellStyle: { textAlign: 'center' }, filter: false },
    { headerName: 'Actual Weight', field: 'actualweight', maxWidth: 110, cellStyle: { textAlign: 'end' }, filter: false },
    { headerName: 'Chargeable Weight', field: 'chargeableweight', maxWidth: 180, cellStyle: { textAlign: 'end' }, filter: false },
    // { headerName: 'Status', field: 'transactionstatus', minWidth: 180, pinned: 'right', cellStyle: { textAlign: 'center' } },
    {
      headerName: 'Status',
      field: 'transactionstatus',
      pinned: 'right',
      minWidth: 145,
      cellRenderer: (params: { value: string; }) => {
        let statusHtml = `<span class="badge bg-light">${params.value}</span>`;
        if (params.value === 'SHIPMENT_BOOKED') {
          statusHtml = `<span class="badge bg-light">BOOKED</span>`;
        } else if (params.value === 'SHIPMENT_RECEIVED') {
          statusHtml = `<span class="badge bg-primary">RECEIVED</span>`;
        } else if (params.value === 'SHIPMENT_PARTIALLY_RECEIVED') {
          statusHtml = `<span class="badge bg-primary">PARTIALLY RECEIVED</span>`;
        } else if (params.value === 'SHIPMENT_PARTIALLY_BAGGED') {
          statusHtml = `<span class="badge bg-info">PARTIALLY BAGGED</span>`;
        } else if (params.value === 'SHIPMENT_BAGGED') {
          statusHtml = `<span class="badge bg-info">BAGGED</span>`;
        } else if (params.value === 'SHIPMENT_PARTIALLY_MANIFESTED') {
          statusHtml = `<span class="badge bg-info">PARTIALLY MANIFESTED</span>`;
        } else if (params.value === 'SHIPMENT_MANIFESTED') {
          statusHtml = `<span class="badge bg-info">MANIFESTED</span>`;
        } else if (params.value === 'SHIPMENT_SENT') {
          statusHtml = `<span class="badge bg-info">SENT</span>`;
        } else if (params.value === 'SHIPMENT_MISROUTED') {
          statusHtml = `<span class="badge bg-danger">MISROUTED</span>`;
        } else if (params.value === 'OUT_FOR_DELIVERY') {
          statusHtml = `<span class="badge bg-warning">OUT FOR DELIVERY</span>`;
        } else if (params.value === 'SHIPMENT_PARTIALLY_DELIVERED') {
          statusHtml = `<span class="badge bg-warning">PARTIALLY DELIVERED</span>`;
        } else if (params.value === 'SHIPMENT_DELIVERED') {
          statusHtml = `<span class="badge bg-success">DELIVERED</span>`;
        } else if (params.value === 'SHIPMENT_INTRANSIT') {
          statusHtml = `<span class="badge bg-success-subtle text-dark">IN-TRANSIT</span>`;
        } else {
          statusHtml = `<span class="badge bg-dark">${params.value.split('_')[1] || params.value}</span>`;
        }
        return statusHtml;
      }
    },
    {
      headerName: 'Actions',
      cellRenderer: AwbEditDeleteActionsRenderer,
      cellClass: 'actions-button-cell',
      colId: 'params',
      filter: false,
      sortable: false,
      pinned: 'right',
      minWidth: 150
    },
  ];

  isResettingFilter = false; // Add this flag to prevent infinite loop
  onFilterChanged() {
    if (this.isResettingFilter) {
      return; // Prevent continuous loop
    }
    this.gridApi.getFilterInstance('bookingdate', (filterInstance) => {
      if (filterInstance) {
        const filterModel = filterInstance.getModel();
        if (!filterModel) {
          this.isResettingFilter = true; // Set flag to prevent loop

          // Reset the filter
          filterInstance.setModel(null);
          this.gridApi.onFilterChanged();

          // Close the popup if it's open
          setTimeout(() => {
            this.gridApi.hidePopupMenu();
            this.isResettingFilter = false; // Reset flag after closing popup
          }, 0);
        }
      }
    });
  }


  rowData = [];
  comment: any;
  inScan: any;
  charCount: any;
  CountReachedMsg = false;
  cellAWbnumber: any;
  selectedSCId: number;
  showForwardingLabel = false;

  constructor(
    public router: Router,
    private fb: FormBuilder,
    private appCoreService: AppCoreService,
    private ngxLoaderService: NgxUiLoaderService,
    private awbService: AWBService,
    public modalService: NgbModal,
    private cdr: ChangeDetectorRef,
    private configService: ConfigService,
    private titleService: Title,
    private creditControlService: CreditControlService,
    private utilities: Utilities,

  ) {
    titleService.setTitle('Air Way Bill');
    this.context = { componentParent: this, actionConfig: { comment: true, podDetails: true, inScan: true, showForwardingLabel: this.showForwardingLabel, lockUnlock: true } };
  }

  ngAfterViewInit() {
    const shortcutMessage = `
    <div class="shortcut-container">
      <ul>  
        <li><strong>New AWB Entry</strong>: <kbd class="shortcut-key">Alt + N</kbd><br></li>
        <li><strong>Focus to Search AWB</strong>: <kbd class="shortcut-key">Alt + S</kbd><br>
        (If a single entry is found), press: <kbd class="shortcut-key">Enter ↩</kbd> to edit that entry</li>
      </ul>  
    </div>
    `;

    this.appCoreService.updateShortcut(shortcutMessage);
  }


  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (!event.altKey) return;

    const actions: { [key: string]: () => void } = {
      n: () => { if (this.permConfig.isAddAllowed) this.router.navigate(['/operation/awb/add']); },
      s: () => {
        this.openColumnFilter('awbnumber');
      }
    };

    const key = event.key.toLowerCase();
    if (actions[key]) {
      event.preventDefault(); // Prevent default browser actions
      actions[key]();
    }
  }

  @HostListener('document:keydown.enter', ['$event'])
  handleSearchEnterEvent(event: KeyboardEvent) {
    this.navigateToSingleRow();
  }

  /** Function to open AG Grid column filter */
  openColumnFilter(columnField: string) {
    if (this.gridApi) {
      this.gridApi.getFilterInstance(columnField, (filterInstance: any) => {
        if (filterInstance) {
          filterInstance.setModel(null); // Clear previous filter (optional)
          this.gridApi.onFilterChanged();
        }
      });

      // Find the header element for the column
      const headerElement = document.querySelector(
        `[col-id="${columnField}"] .ag-header-cell-menu-button`
      ) as HTMLElement;

      if (headerElement) {
        this.gridApi.showColumnMenuAfterButtonClick(columnField, headerElement);
      } else {
        console.warn(`Header element for column "${columnField}" not found.`);
      }
    }
  }

  /** Function to navigate if only one row is found */
  navigateToSingleRow() {
    if (this.gridApi) {
      const filteredRows = this.gridApi.getDisplayedRowCount(); // Count visible rows

      if (filteredRows === 1) {
        const rowNode = this.gridApi.getDisplayedRowAtIndex(0); // Get the first row
        if (rowNode && rowNode.data && rowNode.data.id && this.permConfig.isEditAllowed) {
          this.router.navigate(['/operation/awb/edit', rowNode.data.id]);
        }
      }
    }
  }

  async ngOnInit() {
    const bodyTag = document.body;
    // bodyTag.classList.add('sidebar-enable')
    // bodyTag.classList.add('vertical-collpsed');
    this.filterForm = this.fb.group({
      generatedAndReceivedCheck: [true],
      receivedCheck: [false],
      customerGeneratedCheck: [false],
      generatedByMeCheck: [false]
    });
    this.checkPermission();

    if (this.permConfig.isViewAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe(async (val) => {
        this.selectedSCId = val;
        this.bindList(true);
        this.getUserData();
        if (this.isCreditControlChecked) {
          await this.checkAndBindAvailableCredit();
        }
      });
      this.checkAndBindAvailableCredit();
      await this.getModuleConfigByClientId();
    }
  }

  ngAfterViewChecked() {
    //your code to update the model
    this.cdr.detectChanges();
  }

  async getModuleConfigByClientId() {
    try {
      this.ngxLoaderService.start();
      const res = await lastValueFrom(this.configService.getModuleConfigByClientId());
      if (res) {
        this.ngxLoaderService.stop();
        const creditControl = res.data?.[0]?.planconfig?.moduleconfig?.find(res => res.name === 'Credit Control');
        this.isCreditControlChecked = creditControl?.checked;
      }
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  async checkAndBindAvailableCredit() {
    try {
      const userdata: UserData = this.appCoreService.GetUserData();
      const reqObj = {
        servicecenterid: userdata.accessType === 'Customer' ? null : userdata.selectedServiceCenter,
        customerid: userdata.accessType === 'Customer' ? userdata.metaInfo?.customerid : null
      };
      this.creditControlService.GetByTypeCustomerOrSCId(reqObj).subscribe(res => {
        if (res?.success && res.data?.creditdetails?.balance) {
          const creditDetails: { limit: number; balance: number; used: number; } = res.data.creditdetails
          this.appCoreService.setCreditDetails(creditDetails);
          return true;
        }
      });
    } catch (error) {
      console.error(error);
      return false;
    }
    return false;
  }

  checkPermission(): any {
    const userData = this.appCoreService.GetUserData();
    const permission = userData.config.filter(x => x.categoryname === 'AirWayBills');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  canApply(controlName: string) {
    Object.keys(this.filterForm.controls).forEach((key) => {
      this.filterForm.get(key)?.setValue(key === controlName);
    });

    this.isFilterApplyDisable = false;
  };

  filterAWB() {
    try {
      this.ngxLoaderService.start();
      let customerGeneratedCheck = this.filterForm.get('customerGeneratedCheck')?.value;
      let generatedByMeCheck = this.filterForm.get('generatedByMeCheck')?.value;
      generatedByMeCheck ? localStorage.setItem('generatedByMe', 'true') : null;
      if (customerGeneratedCheck) {
        const obj = {
          selectedSCId: this.selectedSCId,
          createdBy: this.createdBy,
          isCustomerGenerated: this.filterForm.get('customerGeneratedCheck').value,
          isShipmentReceived: this.filterForm.get('receivedCheck').value,
          isGeneratedByMe: this.filterForm.get('generatedByMeCheck').value
        };

        this.awbService.FilterAwb(obj).subscribe(res => {
          if (res && res.success) {
            this.rowData = res.data;
            // this.ngxLoaderService.stop();
          } else {
            this.ngxLoaderService.stop();
          }
        })
      } else if (generatedByMeCheck) {
        const obj = {
          selectedSCId: this.selectedSCId,
          createdBy: this.createdBy,
          isCustomerGenerated: this.filterForm.get('customerGeneratedCheck').value,
          isShipmentReceived: this.filterForm.get('receivedCheck').value,
          isGeneratedByMe: this.filterForm.get('generatedByMeCheck').value
        };

        this.awbService.FilterAwb(obj).subscribe(res => {
          if (res && res.success) {
            this.rowData = res.data;
            // this.ngxLoaderService.stop();
          } else {
            this.ngxLoaderService.stop();
          }
        })
      }
      else {
        const obj = {
          isShipmentGenerated: true,
          isShipmentReceived: this.filterForm.get('receivedCheck').value,
          selectedSCId: this.selectedSCId
        };
        this.awbService.FilterAwb(obj).subscribe(res => {
          if (res && res.success) {
            this.rowData = res.data;
            // this.ngxLoaderService.stop();
          } else {
            this.ngxLoaderService.stop();
          }
        })
      }
    } catch (error) {
      this.ngxLoaderService.stop();
    }
  }


  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.sizeColumnsToFit();
  }

  async updatePODDetails(cell: any) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      centered: true
    };
    //open list then open the modal
    this.ngxLoaderService.start();
    const res = await lastValueFrom(this.awbService.GetInfo({ awbnumber: cell.awbnumber }));
    if (res && res?.success) {
      this.ngxLoaderService.stop();
    };
    const modalRef = this.modalService.open(UpdatePODDetails, ngbModalOptions);
    modalRef.componentInstance.cellData = cell;
    modalRef.componentInstance.cellData.estimateddeliverydate = res?.data?.[0]?.estimateddeliverydate;
    modalRef.componentInstance.awbList = res.data;
    modalRef.result.then(
      (result) => {
        if (result === 'Save Click') {
          this.isFilterApplyDisable ? this.bindList(true) : this.filterAWB()
        }
      },
      (reason) => {
        //on close awb POD Dialog do nothing
      }
    );
  }

  async printPDF(awbNumber: string, printType: string): Promise<void> {
    // Handle the label printing case
    if (printType === 'label') {
      const ngbModalOptions: NgbModalOptions = {
        ariaLabelledBy: 'modal-basic-title',
        size: 'md',
        backdrop: 'static',
        keyboard: false,
        centered: true
      };
      const awbdata = this.rowData.find((item) => item?.awbnumber === awbNumber);
      const modalRef = this.modalService.open(LabelPrintComponent, ngbModalOptions);
      modalRef.componentInstance.awbNumber = awbNumber;
      modalRef.componentInstance.totalPieceNo = awbdata?.totalpieces;
      return;
    }

    // Prepare parameters for PDF generation
    const inputParams = { awbNumber, printType };
    this.ngxLoaderService.start();

    try {
      this.awbService.GeneratePDF(inputParams).subscribe(async (res) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          const pdfString = res.data;
          if (this.isMobileDevice()) {
            this.printPDFMobile(pdfString);
          } else {
            printJS({ printable: pdfString, type: 'pdf', base64: true, showModal: true });
          }
        } else if (res && !res.success) {
          this.ngxLoaderService.stop();
          this.appCoreService.showMessage('PDF Generation Error', '', 'error');
        }
      });
    } catch (error) {
      this.ngxLoaderService.stop();
      console.error('PDF Generation Error:', error);
    }
  }

  isMobileDevice(): boolean {
    return /Mobi|Android/i.test(navigator.userAgent);
  }

  printPDFMobile(pdfString: string): void {
    // console.log("mobile pringing");

    const printWindow = window.open('', '', 'width=600,height=800');

    if (!printWindow) {
      console.error('Failed to open print window');
      return;
    }

    // Write the PDF data into the print window
    printWindow.document.write('<html><head><title>Print</title></head><body>');
    printWindow.document.write('<embed id="pdfEmbed" width="100%" height="100%" src="data:application/pdf;base64,' + pdfString + '" type="application/pdf">');
    printWindow.document.write('</body></html>');

    // Ensure the document is fully loaded before triggering the print dialog
    printWindow.document.close();

    // Get the embed element
    const embedElement = printWindow.document.getElementById('pdfEmbed') as HTMLEmbedElement;

    embedElement.onerror = () => {
      console.error('Failed to load PDF for printing');
      printWindow.close();
    };
  }

  // async printPDF(awbNumber: string, printType: string): Promise<void> {
  //   // console.log('pdf generation for ', awbNumber);
  //   if (printType === 'label') {
  //     const ngbModalOptions: NgbModalOptions = {
  //       ariaLabelledBy: 'modal-basic-title',
  //       size: 'md',
  //       backdrop: 'static',
  //       keyboard: false,
  //       centered: true
  //     };
  //     const awbdata = this.rowData.find((item) => item?.awbnumber === awbNumber);
  //     const modalRef = this.modalService.open(LabelPrintComponent, ngbModalOptions);
  //     modalRef.componentInstance.awbNumber = awbNumber;
  //     modalRef.componentInstance.totalPieceNo = awbdata?.totalpieces;
  //     return;
  //   }

  //   // Prepare parameters for PDF generation
  //   const inputParams = { awbNumber, printType };
  //   this.ngxLoaderService.start();

  //   try {
  //     this.awbService.GeneratePDF(inputParams).subscribe(async (res) => {
  //       if (res && res.success) {
  //         this.ngxLoaderService.stop();
  //         const pdfString = res.data;
  //         printJS({ printable: pdfString, type: 'pdf', base64: true, showModal: true });
  //       }
  //     });
  //   } catch (error) {
  //     this.ngxLoaderService.stop();
  //     console.error('PDF Generation Error:', error);
  //   }
  // }


  addCommentAction(cell: any) {
    const modalRef = this.modalService.open(CommentsComponent, this.ngbModalOptions);
    modalRef.componentInstance.cellAWbnumber = cell?.awbnumber;
    // modalRef.result.then(
    //   (result) => {
    //     if (result) {
    //       // console.log('Closed with: result', result);
    //       this.bindList();
    //     }
    //   },
    //   (reason) => {
    //     // console.log('Dismissed reason', reason);
    //     if (reason !== 'Cross click') {
    //       // this.bindList();
    //     }
    //   }
    // );
  }


  editAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.openErrorDialog('No Access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.router.navigate(['/operation/awb/edit', cell.id]);
      }
    } catch (e) {
      console.error(e);
    }

  }

  copyAction(cell: any) {
    try {
      if (!this.permConfig.isAddAllowed) {
        this.openErrorDialog('No Access to Copy.');
      }
      else if (this.permConfig.isAddAllowed && cell && cell.id) {
        this.router.navigate(['/operation/awb/add'], { queryParams: { type: 'copy', id: cell.id } });
      }
    } catch (e) {
      console.error(e);
    }

  }

  // voidAction(cell: any) {
  //   if (!this.permConfig.isDeleteAllowed) {
  //     this.openErrorDialog('No Access to Delete');
  //   }
  //   else if (this.permConfig.isDeleteAllowed && cell && cell.id) {
  //     this.openConfirmationDialog('Are you sure you want to change Awb status to void ?', cell.id);
  //   }
  // }

  // voidRecord(awbid: any) {
  //   try {
  //     if (awbid) {
  //       this.ngxLoaderService.start();
  //       this.awbService.VoidStatus(awbid).subscribe((res) => {
  //         if (res && res.success) {
  //           this.ngxLoaderService.stop();
  //           this.bindList();
  //         }
  //         if (res && !res.success) {
  //           this.ngxLoaderService.stop();
  //           this.openErrorDialog(res.message);
  //         }
  //       });
  //     }
  //   } catch (e) {
  //     this.ngxLoaderService.stop();
  //     console.error(e);
  //   }
  // }

  // inScanAction(cell: any) {
  //   this.selectedInscan = cell;
  //   this.openInscan();
  // }

  bindList(refresh = false) {
    try {
      this.ngxLoaderService.start();
      this.awbService.GetAllList({ id: this.selectedSCId, refresh: refresh }).subscribe((res: any) => {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.rowData = res.data;
        } else if (res && !res.success) {
          this.ngxLoaderService.stop();
        }
      })
    } catch (e) {
      console.error(e);
      this.ngxLoaderService.stop();
    }
  }

  // openInscan() {
  //   let ngbModalOptions: NgbModalOptions = {
  //     ariaLabelledBy: 'modal-basic-title',
  //     size: 'md',
  //     backdrop: 'static',
  //     keyboard: false,
  //     centered: true
  //   };
  //   const modalRef = this.modalService.open(AwbInscanComponent, ngbModalOptions);
  //   modalRef.componentInstance.selectedInscan = this.selectedInscan;
  //   modalRef.result.then(
  //     (result) => {
  //       if (result) {
  //         // console.log('Closed with: result', result);
  //         this.bindList();
  //       }
  //     },
  //     (reason) => {
  //       // console.log('Dismissed reason', reason);
  //       this.bindList();
  //       if (reason == 'Cross click') {
  //       }
  //     }
  //   );
  // }

  scanAWB() {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      centered: true
    };
    const modalRef = this.modalService.open(AwbReceivedComponent, ngbModalOptions);
    modalRef.componentInstance.inscanSuccess.subscribe(() => {
      this.bindList(true);
    });
    modalRef.result.then(
      (result) => {
        if (result === 'Save Click') {
          // console.log('Closed with: result', result);
          this.bindList(true);
        }
      },
      (reason) => {
        //on close awb POD Dialog do nothing
      }
    );
  }

  // async openConfirmationDialog(msg: any, id?: number) {
  //   const result = await Swal.fire({
  //     titleText: 'Confirmation',
  //     text: msg,
  //     icon: 'warning',
  //     confirmButtonText: 'Yes',
  //     showDenyButton: true,
  //     denyButtonText: 'No',
  //   });
  //   if (result.isConfirmed) {
  //     this.voidRecord(id);
  //   }
  // }

  splitAwb(data: any) {
    if (data.totalpieces <= 1) {
      this.appCoreService.showMessage('Insufficient no. of pieces!', 'Warning', 'warning');
      return;
    }
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
      centered: true
    };
    const modalRef = this.modalService.open(AwbSplitComponent, ngbModalOptions);
    modalRef.componentInstance.AwbNumber = data?.awbnumber;
    modalRef.result.then(
      (result) => {
        if (result) {
          if (result == 'Import Successfully') {
            this.bindList(true);
          }
        }
      },
    );
  }

  async getUserData() {
    let data = this.appCoreService.GetUserData();
    if (!data) {
      return;
    }

    this.createdBy = data.userId;
    await this.getConfigs();
    this.isCustomerLogin = data.accessType == "Customer" ? true : false;
    this.context.actionConfig.isCustomerLogin = this.isCustomerLogin;

    const generateByMe = localStorage.getItem('generatedByMe') ? JSON.parse(localStorage.getItem('generatedByMe')) : false;
    if (generateByMe) {
      this.filterForm.get('generatedByMeCheck').setValue(generateByMe);
      // this.canApply();
      this.filterAWB()
    }
  }

  async openErrorDialog(msg: any) {
    Swal.fire({
      title: 'Ooops!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }

  formatDate(datetime: any): string {
    try {
      const timestamp = new Date(datetime);
      const year = timestamp.getFullYear();
      const month = (timestamp.getMonth() + 1).toString().padStart(2, '0');
      const day = timestamp.getDate().toString().padStart(2, '0');
      return `${day}-${month}-${year}`;
    } catch (error) {
      console.error('Error occurred during date parsing:', error);
      return '';
    }
  }

  async getConfigs() {
    const res = await lastValueFrom(this.configService.getAllGlobalConfig());
    if (res && res.success) {
      let config = res?.data.filter(x => x.configurationcode == 'CUSTOMER_LOGIN_FORWARDING_LABEL');
      this.showForwardingLabel = (this.isCustomerLogin ? config[0].active : true) || false;
      this.context.actionConfig.showForwardingLabel = this.showForwardingLabel;
      //console.log('showForwardingLabel', this.showForwardingLabel);
    }
  }

  tracking() {
    window.open('/operation/awb/track', '_blank');
  }

  uploadDocument(cell) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      centered: true
    };
    const modalRef = this.modalService.open(UploadDocumentComponent, ngbModalOptions);
    modalRef.componentInstance.cellAWbnumber = cell?.awbnumber;
    modalRef.result.then(
      (result) => {
        if (result) {
          this.isFilterAppplyDisable ? this.bindList(true) : this.filterAWB()
        }
      },
      (reason) => {
        //on close awb Dialog do nothing
      }
    );
  }

  lockUnlockAction(cell: any) {
    try {
      if (!this.permConfig.isEditAllowed) {
        this.openErrorDialog('No Access to Edit.');
      }
      else if (this.permConfig.isEditAllowed && cell && cell.id) {
        this.updateLock(cell);
      }

    } catch (e) {
      console.error(e);
    }
  }

  async updateLock(cell: any) {
    const result = await this.openConfirmationDialog('Are you sure ?', `You want to ${cell.islocked ? 'UNLOCK' : 'LOCK'} this AWB.`)
    if (result) {
      try {
        this.ngxLoaderService.start();
        let data = {
          awbnumber: cell.awbnumber,
          islocked: !cell.islocked,
          reason: 'Lock Initiated By User.'
        }
        this.awbService.UpdateEntryLock(data).subscribe((res: any) => {
          if (res && res.success) {
            this.ngxLoaderService.stop();
            if (res?.data) {
              this.bindList(true);
              this.appCoreService.showMessage(`AWB ${data?.islocked ? 'Locked' : 'Un-Locked'} Successfully`);
            }
          } else if (res && !res.success) {
            this.ngxLoaderService.stop();
          }
        })
      } catch (e) {
        console.error(e);
        this.ngxLoaderService.stop();
      }
    }
  }

  async openConfirmationDialog(msg1: any, msg2?: any, id?: number): Promise<boolean> {
    const result = await Swal.fire({
      titleText: 'Confirmation',
      html: msg2 ? `<span>${msg1}</span><br><span>${msg2}</span>` : `<span>${msg1}</span>`,
      icon: 'warning',
      confirmButtonText: 'Yes',
      showDenyButton: true,
      denyButtonText: 'No',
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    if (result.isConfirmed) {
      return true;
    }
  }

  printForwardingLabel(awbNumber) {

    const LinkObj = this.rowData.filter(x => x.awbnumber == awbNumber).map(x => x.vendorlabelfilepath);
    if (LinkObj) {
      const url = LinkObj.toString();
      window.open(url, '_blank');
    }

  }


  async openKycViewModal(data: any) {
    let ngbModalOptions: NgbModalOptions = {
      ariaLabelledBy: 'modal-basic-title',
      size: 'md',
      backdrop: 'static',
      keyboard: false,
      centered: true
    };
    let kycList = [];
    this.ngxLoaderService.start();
    const res = await lastValueFrom(this.awbService.GetDocumentByAwbNumber(data.awbnumber, 'kyc'));
    if (res) {
      this.ngxLoaderService.stop();
      if (res && res?.success) {
        kycList = res.data;

        if (!kycList.some(x => x?.concatenated_urlpath)) return this.appCoreService.showMessage('No Kyc Document Attached to view.', '', 'error');
        kycList = kycList.map(item => ({
          ...item,
          doctype: this.utilities.getFormattedDocType(item.filetype)
        }));
        const modalRef = this.modalService.open(KycViewComponent, ngbModalOptions);
        modalRef.componentInstance.rowData = kycList || [];
        modalRef.result.then(
          (result) => {
            if (result) {
              /* after closing modal */
            }
          },
          (reason) => {
            //on close awb Dialog do nothing
          }
        );
      } else if (res.data?.length == 0) {
        return this.appCoreService.showMessage('No Kyc Document Attached to view.', '', 'error');
      }
    }
  };
}
